module.exports = __webpack_public_path__ + "media/Images/pencil-be58762d9b1708c15718a8bab6769611.svg";